/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./achoo-tab.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./achoo-tab.component";
var styles_AchooTabComponent = [i0.styles];
var RenderType_AchooTabComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AchooTabComponent, data: {} });
export { RenderType_AchooTabComponent as RenderType_AchooTabComponent };
export function View_AchooTabComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 3, "div", [["class", "tab"]], [[8, "hidden", 0]], null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["\n  "])), i1.ɵncd(null, 0), (_l()(), i1.ɵted(-1, null, ["\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.active; _ck(_v, 0, 0, currVal_0); }); }
export function View_AchooTabComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "achoo-tab", [], null, null, null, View_AchooTabComponent_0, RenderType_AchooTabComponent)), i1.ɵdid(1, 4767744, null, 1, i2.AchooTabComponent, [], null, null), i1.ɵqud(335544320, 1, { tabHeading: 0 })], null, null); }
var AchooTabComponentNgFactory = i1.ɵccf("achoo-tab", i2.AchooTabComponent, View_AchooTabComponent_Host_0, { textLabel: "textLabel", active: "active", tabKey: "tabKey", isInfluencerTab: "isInfluencerTab" }, { changed: "changed" }, ["*"]);
export { AchooTabComponentNgFactory as AchooTabComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/achoo-tab/achoo-tab.component.ngfactory.js.pre-build-optimizer.js